var SetTabIndex = function() {
  var $footer = $(document).find("footer");

  if($footer == null || $footer.Length == 0) {
    return;
  }
  var $linkListHeadlineLinks = $footer.eq(0).find(".linklist-link");

  if($linkListHeadlineLinks == null || $linkListHeadlineLinks.Length == 0 ) {
    return;
  }

  if($(window).width() > 767) {
    $linkListHeadlineLinks.each(function() {
      $(this).attr("tabindex", -1);
    });
  } else {
    $linkListHeadlineLinks.each(function() {
      $(this).attr("tabindex", 0);
    });
  }
};

export { SetTabIndex };
